import {
  FORGETPASSWORD_FAIL,
  FORGETPASSWORD_REQUEST,
  FORGETPASSWORD_SUCCESS,
} from "../../constants/actions";
import { postData } from "../../../services/api";
import { ApiURLs } from "../../../constant/ApiUrls";
import { NavigationRoutes } from "../../../constant/Routes";


export const forgotPasswordRequest = (data, navigate) => {
  return async (dispatch) => {

    dispatch(forgotPassRequest());
    try {
      var newPasswordData = await postData(data, ApiURLs.FORGOT_PASSWORD);
      if (newPasswordData.status === 1) {
        navigate(NavigationRoutes.LOGIN);
        dispatch(forgotpassReqSuccess());
      } else {
        dispatch(forgotPassReqFail());
      }
    } catch (error) {
      dispatch(forgotPassReqFail());

    }
  };
};

export const forgotPassRequest = () => {
  return {
    type: FORGETPASSWORD_REQUEST,
  };
};

export const forgotpassReqSuccess = () => {
  return {
    type: FORGETPASSWORD_SUCCESS,
  };
};

export const forgotPassReqFail = (error) => {
  return {
    type: FORGETPASSWORD_FAIL,
    payload: error,
  };
};
